<input [maxLength]="4"
       [gcSelectOnClick]="true"
       class="input"
       [class.blank]="allowUnsetValues"
       [class.disabled]="disabled"
       [class.error]="hasQuantityWarning"
       [formControl]="formControl"
       [readonly]="readonly"
       (blur)="onBlur()">
